// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayCredit_container__37euq","title":"DisplayCredit_title__jTfji"};